import { render, staticRenderFns } from "./leonieandco-review-grid.vue?vue&type=template&id=0687e80b&scoped=true&"
import script from "./leonieandco-review-grid.vue?vue&type=script&lang=js&"
export * from "./leonieandco-review-grid.vue?vue&type=script&lang=js&"
import style0 from "./leonieandco-review-grid.vue?vue&type=style&index=0&id=0687e80b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0687e80b",
  null
  
)

export default component.exports